var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.4 7.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.69,7.42c-1.67,0-2.69-.77-2.69-2.04,0-.68,.37-1.32,1.5-1.79v-.02c-.67-.33-1.2-.79-1.2-1.68C.3,.8,1.17,0,2.72,0s2.42,.71,2.42,1.83c0,.7-.39,1.26-1.2,1.62v.02c1.05,.45,1.46,1.06,1.46,1.88,0,1.32-1.07,2.07-2.71,2.07Zm-.07-3.39c-.79,.29-1.37,.71-1.37,1.3,0,.66,.58,1.07,1.44,1.07,.93,0,1.46-.42,1.46-1.06,0-.73-.73-1.02-1.53-1.31Zm.1-3.06c-.8,0-1.21,.43-1.21,.96,0,.62,.65,.88,1.39,1.14,.57-.24,1.04-.55,1.04-1.15,0-.56-.43-.95-1.22-.95Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.6f9baeb1852bdf5f67a4000d6a3615f7.svg";
export { ForwardRef as ReactComponent };